//system
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';


//services
import { ApiRequestService } from '../services/api-request.service';
import { FiltersService } from '../services/filters.service';
import { MapRendererService } from '../services/map-renderer.service';
import { DisplayMessageToUserService } from "../services/display-to-user-message.service";
import { ClearDataService } from "../services/clear-data.service";



//interfaces
import { PostOfficeInfo } from '../interfaces/post-office-info.interface'
import { City } from '../interfaces/city.interface'



@Injectable({
  providedIn: 'root'
})
export class RenderAndPreviewControllerService {

  private filteredSchaduleAndPostoffices: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private filteredVPZScheduleOffices: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private pvpzIndexSchedule: BehaviorSubject<any> = new BehaviorSubject<any>(null);



  private filteredPostoffices: BehaviorSubject<Array<PostOfficeInfo>> = new BehaviorSubject<Array<PostOfficeInfo>>(null);
  private lastPostofficesNoFilter: Array<PostOfficeInfo> = [];
  private selectedOfficeData: BehaviorSubject<{ officeChoosenFromList: PostOfficeInfo, officeChoosenOnMap: any, scaledUpMarkerFromList: any, scaledUpMarkerFromMap: any }> = new BehaviorSubject<{
    officeChoosenFromList: PostOfficeInfo,
    officeChoosenOnMap: any,
    scaledUpMarkerFromList: any,
    scaledUpMarkerFromMap: any,
  }>({
    officeChoosenFromList: null,
    officeChoosenOnMap: null,
    scaledUpMarkerFromList: null,
    scaledUpMarkerFromMap: null
  })
  private appScreenWidth: number; // 743 max break


  

  constructor(
    private API: ApiRequestService,
    private filter: FiltersService,
    private map: MapRendererService,
    private displayMessage: DisplayMessageToUserService,
    private clear: ClearDataService) {

    this.filter.getSubjectFiltersAfterChange().asObservable().subscribe(newFilters => {
      if (newFilters) {
 
        let error;
        if (!this.lastPostofficesNoFilter || this.lastPostofficesNoFilter.length == 0)
          error = this.displayMessage.getCurrentLang().errors.filtersNotApplyToEmptyOfficesList;

        if (this.lastPostofficesNoFilter.length == 1)
          // error = this.displayMessage.getCurrentLang().errors.filtersNotApplyToOneOffice;
          this.applyNewFiltersToLastDataIndex();

        if (error)
          this.displayMessage.displayMessageOnMap(true, error);

        if (newFilters && this.lastPostofficesNoFilter && this.lastPostofficesNoFilter.length > 1) {
          this.applyNewFiltersToLastData();

        }
      }
    })

    this.appScreenWidth = window.innerWidth;  //screen.width;

    this.clear.getClearSubject().asObservable().subscribe((whatToClear) => {
      if (whatToClear) {
        //if (whatToClear.previewList)
        //this.lastPostofficesNoFilter = [];

      }
    })

  }


  /*

  = = =   U S E     T H I S    S E R V I C E     F O R     S A V I N G     A P P    S T A T E  
  = = =   A N D     M A N A G E      A P P 

  */

  public getScreenWidth() {
    return this.appScreenWidth;
  }

  public getSelectedOfficeDataSubject(): BehaviorSubject<any> {
    return this.selectedOfficeData;
  }


  /////--------  saved temporary markers and selected office data

  public setSelectedOfficeData(data: { officeChoosenFromList: PostOfficeInfo, officeChoosenOnMap: any, scaledUpMarkerFromList: any, scaledUpMarkerFromMap: any }) {
    this.selectedOfficeData.next(data)
  }// add 4 func for each param separate

  public getSelectedOfficeDataValue(): { officeChoosenFromList: PostOfficeInfo, officeChoosenOnMap: any, scaledUpMarkerFromList: any, scaledUpMarkerFromMap: any } {
    return this.selectedOfficeData.getValue()
  }

  public setOfficeChoosenFromList(officeChoosen: PostOfficeInfo) {
    let allData = this.selectedOfficeData.getValue()

    allData.officeChoosenFromList = officeChoosen;
    this.selectedOfficeData.next(allData)
  }

  public setScaledUpMarkerFromList(scaledUpMarker: any) {

    let allData = this.selectedOfficeData.getValue()
    if (scaledUpMarker != allData.scaledUpMarkerFromList) {

      allData.scaledUpMarkerFromList = scaledUpMarker;
      allData.scaledUpMarkerFromMap = null; // need test

      this.selectedOfficeData.next(allData)
    } else {
      //console.warn(' markers are same ', scaledUpMarker, allData.scaledUpMarkerFromList)
    }
  }


  public setScaledUpMarkerFromMap(scaledUpMarker: any) {
    //console.warn('setScaledUpMarkerFromMap', scaledUpMarker)
    let allData = this.selectedOfficeData.getValue()
    if (scaledUpMarker != allData.scaledUpMarkerFromMap) {

      allData.scaledUpMarkerFromMap = scaledUpMarker;
      allData.scaledUpMarkerFromList = null; // need test
      //console.log(allData, "saved to cntrlr", scaledUpMarker)
      this.selectedOfficeData.next(allData)
    } else {
      //console.warn(' markers are same ', scaledUpMarker, allData.scaledUpMarkerFromMap)
    }
  }


  ///////---------- end 

  cityId: any;

  // 30.04.2026 OLD METHOD (START)
  // public async showNewCity(city: City) {
  //   const postOffices: Array<PostOfficeInfo> = await this.API.getPostOfficesAndSchadulesByCityId(city.CITY_ID as any as string) || [];

  //   if (postOffices.length > 0) {
  //     // Якщо це велике місто, пропускаємо важку логіку ПВ
  //     const isLargeCity = postOffices.length > 20;

  //     if (!isLargeCity) {
  //       const tasks = postOffices.map(async (office) => {
  //         const isPV = office.ISVPZ === '1' || office['POSTOFFICE_TYPE'] === 'ПВ';
          
  //         if (isPV) {
  //           const extraSchedule = await this.API.getSchaduleByPostCode(office.POSTCODE || office.POSTINDEX, office.ID);
            
  //           if (extraSchedule && extraSchedule.length > 0) {
  //             // Фільтрація за CITY_ID
  //             const filtered = extraSchedule.filter((s: any) => 
  //               String(s.CITY_ID || s.pdcity_id) === String(city.CITY_ID)
  //             );

  //             // Фільтрація за датою
  //             const today = new Date();
  //             const todayDate = today.getDate();
  //             office.schedule = filtered.filter((day: any) => {
  //               if (!day.DAYS_PERIOD || day.DAYS_PERIOD.toLowerCase().includes("щодня")) return true;
  //               const nums = (day.DAYS_PERIOD.match(/\d+/g) || []).map(Number);
  //               if (nums.length >= 2) {
  //                 for (let i = 0; i < nums.length; i += 2) {
  //                   if (todayDate >= nums[i] && todayDate <= (nums[i + 1] || nums[i])) return true;
  //                 }
  //                 return false;
  //               }
  //               return true;
  //             });

  //             const n = today.getDay() === 0 ? 7 : today.getDay();
  //             office.currentDay = office.schedule.find((d: any) => Number(d.DAYOFWEEK_NUM) === n) || null;
  //           }
  //         }
  //       });

  //       await Promise.all(tasks);
  //     }

  //     this.lastPostofficesNoFilter = postOffices;
  //     this.filterOffices(postOffices);
  //   } else {
  //     this.map.clearMap();
  //     this.clear.emitClearObjectOptional({ Map: true, Dropdown: false, previewList: true, previewSelected: true });
  //     this.displayMessage.displayMessageOnMap(true, this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCity);
  //   }
  // }
  // 30.04.2026 OLD METHOD (END)

  // 08.05.2026 NEW METHOD (START)
  
  public async showNewCity(city: City) {
    const postOffices: Array<PostOfficeInfo> = 
      await this.API.getPostOfficesAndSchadulesByCityId(city.CITY_ID as any as string) || [];

    if (postOffices.length > 0) {
      const isLargeCity = postOffices.length > 25;

      if (!isLargeCity) {
        const tasks = postOffices.map(async (office) => {
          const isPV = office.ISVPZ === '1' || office['POSTOFFICE_TYPE'] === 'ПВ';
          const hasNoSchedule = !office.schedule || office.schedule.length === 0;

          if (isPV && hasNoSchedule) {
            const extraSchedule = await this.API.getSchaduleByPostCode(office.POSTCODE || office.POSTINDEX, office.ID);
            
            if (extraSchedule && extraSchedule.length > 0) {
              const filtered = extraSchedule.filter((s: any) => 
                String(s.CITY_ID || s.pdcity_id) === String(city.CITY_ID)
              );

              const today = new Date();
              const todayDate = today.getDate();
              office.schedule = filtered.filter((day: any) => {
                if (!day.DAYS_PERIOD || day.DAYS_PERIOD.toLowerCase().includes("щодня")) return true;
                const nums = (day.DAYS_PERIOD.match(/\d+/g) || []).map(Number);
                if (nums.length >= 2) {
                  for (let i = 0; i < nums.length; i += 2) {
                    if (todayDate >= nums[i] && todayDate <= (nums[i + 1] || nums[i])) return true;
                  }
                  return false;
                }
                return true;
              });

              const n = today.getDay() === 0 ? 7 : today.getDay();
              office.currentDay = office.schedule.find((d: any) => Number(d.DAYOFWEEK_NUM) === n) || null;
            }
          }
        });

        await Promise.all(tasks);
      }

      this.lastPostofficesNoFilter = postOffices;
      this.filterOffices(postOffices);
    } else {
      this.map.clearMap();
      this.clear.emitClearObjectOptional({ Map: true, Dropdown: false, previewList: true, previewSelected: true });
      this.displayMessage.displayMessageOnMap(true, this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCity);
    }
  }
  // 08.05.2026 NEW METHOD (END)

  // 29.04.2026 OLD METHOD (START)
  // public byIndex(postIndex: string) {

  //   this.API.getPostOfficeInfoAndSchaduleByIndex(postIndex).then(office => {
  //     if (office) {

  //       let pdId = office[0].PDCITY_ID;

  //       let id = office[0].ID;

  //       this.API.getScheduleVpzById(id as any as string).then(data => {

  //         if(data) {

  //           let val = data.filter(object => {

  //             if(object.CITY_ID == pdId) {
  //               return object
  //             }

  //           });

  //           // Group on DAYS_PERIOD
  //           let groupedByDaysPeriod = Object.entries(val.reduce((newKey, object) => {
  //             const key = object.DAYS_PERIOD;

  //             if (!newKey[key]) {
  //               newKey[key] = [];
  //             }

  //             newKey[key].push(object); 

  //             return newKey;
  //           }, {}));
            
  //           this.pvpzIndexSchedule.next(groupedByDaysPeriod);

  //         }
  //       })

  //       this.filterIndex(office);
  //     }
  //   });
  // }
  // 29.04.2026 OLD METHOD (END)

  
  // 29.04.2026 NEW METHOD (START)
  public async byIndex(postIndex: string) {
    const office = await this.API.getPostOfficeInfoAndSchaduleByIndex(postIndex);
    
    if (office && office.length > 0) {
        this.filterIndex(office);
    } else {
    }
  }
  // 29.04.2026 NEW METHOD (END)

  public showNewPostoffices(postOffices: Array<PostOfficeInfo>) {
    if (postOffices) {
      if (!(postOffices[0] as any).error) {

        this.filterOffices(postOffices);

      } else {
        this.map.clearMap();
        this.map.showError(true);
      }

    }// postoffices
  }

  public filterIndex(office) {

    let officeFiltered = this.filter.filterOfficesByEnabledFilters(office);

    this.filteredPostoffices.next(officeFiltered);
    this.filteredSchaduleAndPostoffices.next(officeFiltered); // add schadule to offices obj

    if (officeFiltered.length === 0) {
      let error = this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCityAfterFilterApply;

      this.displayMessage.displayMessageOnMap(true, error);
      this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true })
    } else if (!(office as any).error) {
      
      this.lastPostofficesNoFilter = officeFiltered;

      this.filteredPostoffices.next(officeFiltered); // filtered

      this.filteredSchaduleAndPostoffices.next(officeFiltered); // add schadule to offices obj

      this.map.drawOfficesOnMap(officeFiltered); // out of IF for passing error to target element // deprecated need review

      let pointsFromObjects = this.map.createPointsArrayFromOfficesArray(officeFiltered);
      this.map.focusMapCenterAtMiddleOfManyPoints(pointsFromObjects);
      this.displayMessage.displayMessageOnMap(false);

      if (officeFiltered.length === 0) {
        let error = this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCityAfterFilterApply;
        this.displayMessage.displayMessageOnMap(true, error);
        this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true })
      }
      
    } else {
      let error = this.displayMessage.getCurrentLang().errors.postIndexNotFound;
      this.displayMessage.displayMessageOnMap(true, error);
      this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true })
    }
  }


  public filterOffices(postOffices: Array<PostOfficeInfo>) {

    if (postOffices && postOffices.length > 0) {
      let filtered = this.filter.filterOfficesByEnabledFilters(postOffices);
      this.filteredPostoffices.next(filtered);
      this.filteredSchaduleAndPostoffices.next(filtered); // add schadule to offices obj

      if (filtered && filtered.length != 0) {

        this.map.drawOfficesOnMap(filtered); // postOffices // out of IF for passing error to target element
        let pointsFromObjects = this.map.createPointsArrayFromOfficesArray(filtered); // postOffices
        this.map.focusMapCenterAtMiddleOfManyPoints(pointsFromObjects);
        // this.displayMessage.displayMessageOnMap(false);
      } else {
        // show error no offices after filter done // already
        //this.map.drawOfficesOnMap([]); // test this
        this.map.clearMap();
        let message = this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCityAfterFilterApply;
        this.displayMessage.displayMessageOnMap(true, message);
        this.clear.emitClearObjectOptional({ previewList: true, previewSelected: true })
      }
    } else {
      let message = this.displayMessage.getCurrentLang().errors.validSymbolsForInput;
      this.displayMessage.displayMessageOnMap(true, message);
    }

  }

  public applyNewFiltersToLastDataIndex() {

    this.filterIndex(this.lastPostofficesNoFilter)
  }

  public applyNewFiltersToLastData() {

    this.filterOffices(this.lastPostofficesNoFilter)

  }

  public getFilteredOfficesAndScadulesSubject(): BehaviorSubject<any> {
    return this.filteredSchaduleAndPostoffices;
  }


  public getFilteredVPZOffices(): BehaviorSubject<any> {
    return this.filteredVPZScheduleOffices;
  }


  public getpvpzIndexSchedule(): BehaviorSubject<any> {
    return this.pvpzIndexSchedule;
  }


  public getFilteredOfficesSubject(): BehaviorSubject<Array<PostOfficeInfo>> {
    return this.filteredPostoffices;
  }


  public setOfficeSelectedOnMap(latLng: [number, number]) {
    let selectedOfficeObject = this.getOfficeInfoByCoordinates(latLng);
    // shoud check office aftel check  add in feature
    let allData: { officeChoosenFromList: PostOfficeInfo, officeChoosenOnMap: any, scaledUpMarkerFromList: any, scaledUpMarkerFromMap: any } = this.selectedOfficeData.getValue()
    allData.officeChoosenFromList = null;
    this.map.deleteScaledUpMarker(allData.scaledUpMarkerFromList); // will auto deleted from map component func allData.scaledUpMarkerFromList = null; // delete it 

    allData.officeChoosenOnMap = selectedOfficeObject;
    this.selectedOfficeData.next(allData);

  }


  public getOfficeInfoByCoordinates(latLng: [number, number]) {
    // + convert to string 
    // +office.LATTITUDE
    // means     '' + office.LATTITUDE   result is cast to string
    let afterFilter = this.lastPostofficesNoFilter.filter((office: PostOfficeInfo) => {
      return +office.LATTITUDE == latLng[0] && +office.LONGITUDE == latLng[1];
    })

    return (afterFilter && afterFilter[0] || []);

  }



}

